    <ng-container *ngIf="controlTemplate?.settings?.value !== undefined; else noValue">
        {{ controlTemplate?.settings?.value }}<span *ngIf="showSuffix()"> {{controlTemplate?.settings?.suffix}}</span>
    </ng-container>
    <ng-template #noValue>
        -
    </ng-template>